import { Button, ButtonProps, CircularProgress } from '@mui/material';

export type LoadingButtonProps = ButtonProps & {
  loading?: boolean;
};

export function LoadingButton({ loading, ...rest }: LoadingButtonProps) {
  return (
    <Button
      {...rest}
      {...(loading
        ? {
            disabled: true,
            startIcon: <CircularProgress size={24} />,
            endIcon: null,
          }
        : {})}
    />
  );
}
